import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { TitleActions } from '@app-shared/store/title/title.actions';
import { Store } from '@ngrx/store';
import { MatButton } from '@angular/material/button';

@Component({
  imports: [MatCardModule, RouterLink, MatButton],
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent implements OnInit {
  title = $localize`:@@PIECES-NOT-FOUND-PAGE:PIECES-NOT-FOUND-PAGE`;
  store = inject(Store);

  ngOnInit(): void {
    this.store.dispatch(TitleActions.updateTitle({ title: this.title }));
  }
}
